import React from "react";
import { Link } from "react-router-dom";
import "./About.scss";

const focusAreas = [
    {
        number: "01",
        title: "Technology Solutions",
        description:
            "We design and develop web, mobile, Smart TV, and IoT solutions that connect business needs with practical technology.",
        link: "/#what-we-build",
        linkText: "Explore What We Build",
        externalPage: true,
    },
    {
        number: "02",
        title: "Invest Africa",
        description:
            "We connect international businesses with opportunities across Africa through market exploration, partnerships, and project development.",
        link: "/invest-africa",
        linkText: "Discover Invest Africa",
    },
    {
        number: "03",
        title: "Our Ventures",
        description:
            "We develop our own technology ventures, including Nabeba and Goldensoko, turning ideas into digital products.",
        link: "/#ventures",
        linkText: "Explore Our Ventures",
        externalPage: true,
    },
];

const stats = [
    { value: "7", label: "Years Building Products" },
    { value: "12", label: "Clients Served" },
    { value: "14", label: "Projects Delivered" },
];

const AboutPage = () => {
    return (
        <div className="about">
            <section
                className="about__hero"
                aria-labelledby="about-title"
            >
                <div className="about__container">
                    <p className="about__eyebrow">About Techadive</p>

                    <h1 id="about-title">
                        We Build. We Connect. <span>We Innovate.</span>
                    </h1>

                    <p className="about__lead">
                        Techadive brings together software engineering, technology
                        ventures, and business connections across Africa.
                    </p>
                </div>
            </section>

            <section
                className="about__section"
                aria-labelledby="about-story-title"
            >
                <div className="about__container about__split">
                    <div>
                        <p className="about__eyebrow">Our Story</p>

                        <h2 id="about-story-title">
                            From Ideas to <span>Impact.</span>
                        </h2>
                    </div>

                    <div className="about__body">
                        <p>
                            Techadive was founded by <strong>Roy Sylvanus</strong>,
                            a Kenyan software engineer based in Poland, with experience
                            in full-stack development, Android and iOS engineering,
                            and UI/UX design.
                        </p>

                        <p>
                            Our work starts with building digital products that help
                            businesses operate, connect, and grow. That foundation also
                            supports our own ventures and our ambition to connect
                            international businesses with opportunities across Africa.
                        </p>

                        <p>
                            Through technology development and collaboration, we turn
                            ideas into practical next steps.
                        </p>
                    </div>
                </div>
            </section>

            <section
                className="about__section"
                aria-labelledby="about-focus-title"
            >
                <div className="about__container">
                    <div className="about__section-header">
                        <p className="about__eyebrow">Our Focus</p>

                        <h2 id="about-focus-title">
                            Three Directions. <span>One Vision.</span>
                        </h2>
                    </div>

                    <ul className="about__grid">
                        {focusAreas.map((area) => (
                            <li className="about__card" key={area.number}>
                <span className="about__number" aria-hidden="true">
                  {area.number}
                </span>

                                <h3>{area.title}</h3>
                                <p>{area.description}</p>

                                {area.externalPage ? (
                                    <a className="about__link" href={area.link}>
                                        {area.linkText}
                                        <span aria-hidden="true">↗</span>
                                    </a>
                                ) : (
                                    <Link className="about__link" to={area.link}>
                                        {area.linkText}
                                        <span aria-hidden="true">↗</span>
                                    </Link>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            </section>

            <section
                className="about__section"
                aria-labelledby="about-mission-title"
            >
                <div className="about__container">
                    <div className="about__mission">
                        <p className="about__eyebrow">Our Mission</p>

                        <h2 id="about-mission-title">
                            Build with Purpose. <span>Connect Possibilities.</span>
                        </h2>

                        <p className="about__mission-description">
                            To create reliable, user-focused technology and develop
                            relationships that help businesses and ideas move forward.
                            We aim to bring thoughtful engineering and practical
                            collaboration to every project we undertake.
                        </p>

                        <dl className="about__stats">
                            {stats.map((stat) => (
                                <div className="about__stat" key={stat.label}>
                                    <dt>{stat.label}</dt>
                                    <dd>{stat.value}</dd>
                                </div>
                            ))}
                        </dl>
                    </div>
                </div>
            </section>

            <section
                className="about__section"
                aria-labelledby="about-contact-title"
            >
                <div className="about__container about__contact">
                    <div>
                        <p className="about__eyebrow">Work with Techadive</p>

                        <h2 id="about-contact-title">
                            Let’s Move Your <span>Idea Forward.</span>
                        </h2>

                        <p>
                            Talk to us about a digital product, a partnership,
                            or an opportunity you want to explore.
                        </p>
                    </div>

                    <Link className="about__button" to="/contact">
                        Let’s Talk
                        <span aria-hidden="true">↗</span>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default AboutPage;